// client/src/hooks/useModules.js
// Per-camp modules config (the "מודולים" tab).

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

const key = (campId) => ['camps', campId, 'modules'];

export function useModules(campId) {
  return useQuery({
    queryKey: key(campId),
    queryFn: () => api.get(`/api/camps/${campId}/modules`).then((r) => r.modules),
    enabled: !!campId,
  });
}

export function useUpdateModule(campId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ key: moduleKey, enabled, config }) =>
      api.put(`/api/camps/${campId}/modules/${moduleKey}`, { enabled, config }),
    onSuccess: () => qc.invalidateQueries({ queryKey: key(campId) }),
  });
}
